import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-759e78e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "contact",
  id: "contact"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Contacto", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Para ponerse en contacto con nosotros, puede hacer clic en los enlaces que se encuentran en esta sección de la página.", -1))
const _hoisted_5 = { class: "contact__row" }
const _hoisted_6 = { class: "map" }
const _hoisted_7 = {
  href: "https://goo.gl/maps/55yKBsmUJ1SafLMZ6",
  target: "_blank"
}
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "mailto:silverwolfmotores@gmail.com" }, "silverwolfmotores@gmail.com"),
  /*#__PURE__*/_createElementVNode("a", { href: "tel:+59894188629" }, "094 188 629"),
  /*#__PURE__*/_createElementVNode("a", { href: "https://goo.gl/maps/55yKBsmUJ1SafLMZ6" }, "Hipólito Yrigoyen 2432")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("a", _hoisted_7, [
            _createElementVNode("img", {
              src: require('@/assets/images/contact_map.png'),
              alt: ""
            }, null, 8, _hoisted_8)
          ])
        ]),
        _hoisted_9
      ])
    ])
  ]))
}